__turbopack_context__.v({
  "applyBtn": "ScholarshipOffers-module-scss-module__Ar5OVa__applyBtn",
  "badge": "ScholarshipOffers-module-scss-module__Ar5OVa__badge",
  "badgeIcon": "ScholarshipOffers-module-scss-module__Ar5OVa__badgeIcon",
  "card": "ScholarshipOffers-module-scss-module__Ar5OVa__card",
  "cardHeader": "ScholarshipOffers-module-scss-module__Ar5OVa__cardHeader",
  "cardTitle": "ScholarshipOffers-module-scss-module__Ar5OVa__cardTitle",
  "cardTop": "ScholarshipOffers-module-scss-module__Ar5OVa__cardTop",
  "eligibilityLabel": "ScholarshipOffers-module-scss-module__Ar5OVa__eligibilityLabel",
  "eligibilityText": "ScholarshipOffers-module-scss-module__Ar5OVa__eligibilityText",
  "grid": "ScholarshipOffers-module-scss-module__Ar5OVa__grid",
  "header": "ScholarshipOffers-module-scss-module__Ar5OVa__header",
  "iconBox": "ScholarshipOffers-module-scss-module__Ar5OVa__iconBox",
  "modal": "ScholarshipOffers-module-scss-module__Ar5OVa__modal",
  "modalApply": "ScholarshipOffers-module-scss-module__Ar5OVa__modalApply",
  "modalClose": "ScholarshipOffers-module-scss-module__Ar5OVa__modalClose",
  "modalOverlay": "ScholarshipOffers-module-scss-module__Ar5OVa__modalOverlay",
  "modalSelect": "ScholarshipOffers-module-scss-module__Ar5OVa__modalSelect",
  "modalTitle": "ScholarshipOffers-module-scss-module__Ar5OVa__modalTitle",
  "section": "ScholarshipOffers-module-scss-module__Ar5OVa__section",
  "subtitle": "ScholarshipOffers-module-scss-module__Ar5OVa__subtitle",
  "title": "ScholarshipOffers-module-scss-module__Ar5OVa__title",
});
